import { Box, Typography } from '@mui/material'
import { IconPhoto } from '@tabler/icons-react'
import { SUPPLIER_CONFIG, channels } from '../../constants'

export const getSupplierLabel = (supplier: string): string => {
  const config = SUPPLIER_CONFIG[supplier]
  if (config) return config.label
  const channel = channels.find((c) => c.value === supplier)
  return channel?.label ?? supplier.charAt(0).toUpperCase() + supplier.slice(1)
}

interface SupplierLogoProps {
  supplier: string | null
  size?: number
  showLabel?: boolean
}

const SupplierLogo: React.FC<SupplierLogoProps> = ({ supplier, size = 20, showLabel = true }) => {
  if (!supplier) return null

  const config = SUPPLIER_CONFIG[supplier]
  const Icon = config?.icon ?? IconPhoto
  const color = config?.color ?? 'text.secondary'
  const label = getSupplierLabel(supplier)

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 0.5,
        color: config ? color : 'text.secondary',
        fontWeight: 600,
        fontSize: '0.875rem',
      }}
    >
      <Icon size={size} color={config ? color : undefined} />
      {showLabel && <Typography variant="body2">{label}</Typography>}
    </Box>
  )
}

export default SupplierLogo
